exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.padbox[data-v-11450013] {\n  width: 100%;\n  height: 100%;\n}\n.pdfClass[data-v-11450013] {\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 0;\n}", ""]);

// exports
